import { useDroppable } from "@dnd-kit/core";
import { twMerge } from "tailwind-merge";

import { Button, Icon } from "@smart/itops-sb-design-system-dom";

import { getDraggingClassNames, wrapperClassNames } from "./class-names";
import { droppableSeparatorIdPrefix } from "../constants";

const CallToAction = ({ onClick }: { onClick: () => void }) => {
  const dashClassName =
    "flex items-center justify-center w-[10rem] border border-neutral-100";

  return (
    <>
      <div className="flex items-center justify-center gap-small my-[1.5rem]">
        <div className={dashClassName} />
        <div className="text-caption text-neutral-500">or use a shortcut</div>
        <div className={dashClassName} />
      </div>
      <Button
        variant="primarySubtle"
        onClick={onClick}
        text="Add contact details"
        leftIcon={<Icon name="solidContactCard" />}
      />
    </>
  );
};

export const EmptyStateDroppable = ({
  index,
  disabled,
  variant,
  openContactDetailsModal,
}: {
  index: number;
  disabled?: boolean;
  variant: "form" | "section";
  openContactDetailsModal: () => void;
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `${droppableSeparatorIdPrefix}|${index}`,
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      className={twMerge(
        wrapperClassNames,
        getDraggingClassNames(isOver, true, "m"),
      )}
    >
      <div className="flex flex-col items-center justify-center gap-small p-[3rem] max-w-[60%] mx-auto text-center">
        {variant === "form" && (
          <>
            <div className="flex items-center justify-center w-[4rem] h-[4rem] bg-neutral-100 rounded">
              <Icon
                name="lightGrid2Plus"
                className="w-[2rem] h-[2rem] text-neutral-500"
              />
            </div>
            <div className="text-paragraph font-semibold font-poppins text-neutral-750">
              Start building your form
            </div>
          </>
        )}
        <div className="text-ui text-neutral-500">
          {variant === "form"
            ? "Drag any component from the panel on the right onto the canvas to get started."
            : "Drag and drop 'Components' to build your form."}
        </div>
        <CallToAction onClick={openContactDetailsModal} />
      </div>
    </div>
  );
};
